'use strict';

var React = require('react');

var SvgTitleMinor = function SvgTitleMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3 2a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0 2 2 0 0 1 2-2h2v10.999a1 1 0 0 1-1 1.001h-.001a1 1 0 0 0 .001 2h6a1 1 0 1 0 0-2 1 1 0 0 1-1-1v-11h2a2 2 0 0 1 2 2 1 1 0 1 0 2 0v-3a1 1 0 0 0-1-1h-14z"
  }));
};

exports.SvgTitleMinor = SvgTitleMinor;
